module.exports = __webpack_public_path__ + "img/errorReaction.da65d627.jpg";